import { Button,  SaveIcon} from "melco-ui";
import { useTranslation } from "react-i18next";
import {    useConfirm } from "melco-shared-logic";
import { useFormikContext } from "formik";



type AddProfileConfirmButtonProps = {

};

export const AddProfileConfirmButton: React.FC<
    AddProfileConfirmButtonProps
> = () => {
    const { t } = useTranslation();
    const { submitForm, values } = useFormikContext();

    const confirmGenerate = useConfirm(
        async () => {

            submitForm();


        },
        {
            translationPrefix: [
                "users.actions",
                "add",
            ].join("."),



        }
    );





    return (

        <>
            <Button
                icon={<SaveIcon />}
                type="primary"

                onClick={(values) => {

                    confirmGenerate();

                }}
            >
                {t("users.actions.add.button")}
            </Button></>
    );
};
